import NotFound from './NotFound';

export default {
  NotFound,
};



// WEBPACK FOOTER //
// ./src/views/Exceptions/index.js